import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import { useForm, Controller } from "react-hook-form";
import { DevTool } from "@hookform/devtools";
import http from "../services/reportsPath";
import toast from "react-hot-toast";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import TableAddReviewReq from "./portfolioReview/tableAddReviewReq";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});

const AddportfolioReview = () => {
  const classes = useStyles();
  const form = useForm({
    defaultValues: {
      mobile: "",
      clientname: "",
      securityName: "",
      quantity: "",
      avgpurchasedprice: "",
      // investedamt: "",
      // specialrequest: false,
    },
  });

  const [checkVerification, setcheckVerification] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [disable, setdisable] = useState(true);
  const [tabledata, settabledata] = useState([]);

  const { handleSubmit, register, control, setValue, watch, getValues, reset } =
    form;

  const onSubmit = (data, e) => {
    const fieldDisplayNames = {
      quantity: "Quantity",
      avgpurchasedprice: "Average Purchased Share Price",
      clientname: "Client Name",
      mobile: "Mobile Number",
      securityName: "Security Name",
      // Add more field display names as needed
    };

    const requiredProperties = ["clientname", "mobile", "securityName"];
    const optionalFields = ["quantity", "avgpurchasedprice"];

    const missingRequiredFields = requiredProperties.filter(
      (property) =>
        data[property] === undefined ||
        data[property] === null ||
        data[property] === ""
    );

    const missingOptionalFields = optionalFields.filter((field) =>
      field === "quantity"
        ? data[field] !== "" && data["avgpurchasedprice"] === ""
        : field === "avgpurchasedprice"
        ? data[field] !== "" && data["quantity"] === ""
        : data[field] === ""
    );

    const allPropertiesValid =
      missingRequiredFields.length === 0 && missingOptionalFields.length === 0;

    if (allPropertiesValid) {
      const mobileParam = `mobile=${data.mobile}`;
      const assetIdParam = `asset_id=${data.securityName}`;
      const queryParamsArray = [mobileParam, assetIdParam];

      if (data.quantity !== "") {
        queryParamsArray.push(`quantity=${data.quantity}`);
      }

      if (data.avgpurchasedprice !== "") {
        queryParamsArray.push(`asp=${data.avgpurchasedprice}`);
      }

      const queryParams = queryParamsArray.join("&");

      http
        .get("/save_security_for_review?" + queryParams)
        .then((res) => {
          if (res.data.statusCode === 0) {
            reqTableRow(res.data.Data.advise_id);
          } else if (res.data.statusCode === 1) {
            toast.error(res.data.error);

            setcheckVerification(false);

            setValue("securityName", "", {
              shouldDirty: false,
              shouldTouch: false,
            });
            // Set the fields empty
            reset();
            setdisable(true);
            setCompanyList([]);
          }
        })
        .catch((err) => {
          // toast.error(err);
        });
    } else {
      // Missing or invalid properties detected
      const missingFieldNames = [
        ...missingRequiredFields.map((field) => fieldDisplayNames[field]),
        ...missingOptionalFields.map((field) => fieldDisplayNames[field]),
      ];

      toast.error(
        `The following fields are missing or incomplete: ${missingFieldNames.join(
          ", "
        )}`
      );
    }
  };

  const handleVerify = () => {
    const mobileNumber = getValues("mobile");
    if (
      mobileNumber != undefined &&
      mobileNumber != "" &&
      mobileNumber.length > 5
    ) {
      http
        .get(`/validate_user?mobile_number=${mobileNumber}`)
        .then((res) => {
          // console.log(res.data, "res.data");
          if (res.data.statusCode === 0) {
            toast.success("User Id Verified");

            setValue("clientname", res.data.Data.name, {
              shouldDirty: true,
              shouldTouch: true,
            });

            setcheckVerification(true);
            setdisable(false);
          } else if (res.data.statusCode === 1) {
            toast.error(res.data.error);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toast.error("Enter Valid Mobile Number");
    }
  };

  const handleSearchSecurity = (event) => {
    let companyName = event.target.value;
    // console.log(companyName);

    if (
      companyName.length > 0 &&
      companyName !== undefined &&
      companyName !== null
    ) {
      http
        .get("/search_company?search_term=" + companyName)
        .then((response) => {
          // console.log(response.data.Data);

          setCompanyList(response.data.Data);
        })
        .catch((error) => {});
    }
  };

  const handleSearchSecurityValue = (event, value) => {
    // console.log(event.target.value, "yahoo");
    // console.log(value, "haha");

    if (value !== undefined && value !== "" && value !== null) {
      setValue("securityName", value.id, {
        shouldDirty: true,
        shouldTouch: true,
      });
    } else {
      setValue("securityName", "", {
        shouldDirty: false,
        shouldTouch: false,
      });
    }
  };

  const reqTableRow = (adviseID) => {
    if (adviseID) {
      http
        .get(`/fetch_advise?advise_id=${adviseID}`)
        .then((res) => {
          if (Array.isArray(res.data.Data) && res.data.Data.length === 1) {
            settabledata((prevtableData) => {
              const existingIndex = prevtableData.findIndex(
                (data) => data.request_id === res.data.Data[0].request_id
              );

              const updatedTableData = [...prevtableData];

              if (existingIndex !== -1) {
                updatedTableData[existingIndex] = res.data.Data[0];
              } else {
                updatedTableData.push(res.data.Data[0]);
              }

              return updatedTableData;
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const sentToReview = () => {
    const lastRequestId = tabledata[tabledata.length - 1]?.request_id;

    // console.log(lastRequestId, "lastRequestId");
    http
      .get(`/submit_to_research_team?new_status=R&req_id=` + lastRequestId)
      .then((res) => {
        if (res.data.statusCode === 0) {
          toast.success("Successfully raised Review Request");

          // Enable Verify Button
          setcheckVerification(false);

          // Set the fields empty
          reset();
          setdisable(true);

          // set security name empty
          setValue("securityName", "", {
            shouldDirty: false,
            shouldTouch: false,
          });

          setCompanyList([]);
          settabledata([]); //Empty the table
        } else if (res.data.statusCode === 1) {
          toast.error(res.data.error);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // console.log(tabledata, "tabledata");
  return (
    <>
      {/* <h1>{rendercount}</h1> */}
      <Paper elevation={2} sx={{ padding: 2, marginBottom: 5 }}>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div
            style={{
              display: "flex",
              gap: 50,
              marginBottom: 40,
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 5,
                width: "350px",
              }}
            >
              <TextField
                size="medium"
                className="portfolioTextfield"
                label="Mobile Number"
                type="number"
                {...register("mobile")}
                sx={{ width: "250px" }}
                InputLabelProps={{ shrink: !!watch("mobile") }}
              />
              {checkVerification ? (
                <Button
                  color="success"
                  variant="contained"
                  sx={{ backgroundColor: "#2e7d32" }}
                >
                  Verified
                </Button>
              ) : (
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleVerify}
                  sx={{ backgroundColor: "#3f51b5" }}
                >
                  Verify
                </Button>
              )}
            </div>
            <div>
              <TextField
                size="medium"
                label="Client Name"
                type="text"
                placeholder="Enter"
                {...register("clientname")}
                disabled
                name="clientname"
                variant="outlined"
                InputLabelProps={{ shrink: !!watch("clientname") }}
                sx={{ width: "350px" }}
              />
            </div>

            <Autocomplete
              key={disable} // This is just to render the field again so we can empty it
              disabled={disable}
              sx={{ width: 350 }}
              componentsProps={{
                paper: {
                  sx: {
                    width: 450,
                  },
                },
              }}
              options={companyList}
              autoHighlight
              getOptionLabel={(option) =>
                option.companyname ? option.companyname : ""
              }
              filterOptions={(options, { inputValue }) => {
                const lowerInputValue = (inputValue || "").toLowerCase();
                return options.filter((option) => {
                  if (!option) {
                    return false; // Skip this option if it's null or undefined
                  }

                  const companyName = option?.companyname?.toLowerCase() || "";
                  const ticker = option?.ticker?.toLowerCase() || "";
                  const code = option?.code?.toLowerCase() || "";

                  return (
                    companyName.includes(lowerInputValue) ||
                    ticker.includes(lowerInputValue) ||
                    code.includes(lowerInputValue)
                  );
                });
              }}
              renderOption={(props, option) => (
                <Box component="li" {...props} style={{ width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      padding: 1,
                    }}
                  >
                    <div
                      style={{
                        width: "150px",
                        // border: "1px solid red",
                        fontSize: "14px",
                        fontWeight: "700",
                      }}
                    >
                      {option.ticker}
                    </div>
                    <div
                      style={{
                        width: "250px",
                        fontSize: "16px",
                        // border: "1px solid green",
                      }}
                    >
                      {option.companyname}
                      <div style={{ fontSize: "13px", color: "#3f51b5" }}>
                        {" "}
                        {option.code}
                      </div>
                    </div>
                  </div>
                  {/* {option.companyname} {option.code} {option.ticker} */}
                </Box>
              )}
              onChange={handleSearchSecurityValue}
              renderInput={(params) => (
                <TextField
                  onChange={handleSearchSecurity}
                  {...params}
                  label="Security Name"
                />
              )}
            />
          </div>

          <div style={{ display: "flex", gap: 50 }}>
            <TextField
              disabled={disable}
              label="Quantity"
              type="number"
              {...register("quantity")}
              sx={{ width: "350px" }}
            />
            <TextField
              disabled={disable}
              label="Avg. Purchased Share Price"
              type="number"
              {...register("avgpurchasedprice")}
              name="avgpurchasedprice"
              variant="outlined"
              InputLabelProps={{ shrink: !!watch("avgpurchasedprice") }}
              sx={{ width: "350px" }}
            />
            <Button
              sx={{ backgroundColor: "#3f51b5", width: "100px" }}
              type="submit"
              variant="contained"
              disabled={disable}
            >
              Add
            </Button>
          </div>
        </form>

        <DevTool control={control} />
      </Paper>
      {tabledata.length > 0 ? (
        <Paper className={classes.root} elevation={2} sx={{ padding: 2 }}>
          <TableAddReviewReq
            tableRows={tabledata}
            settabledata={settabledata}
            reqTableRow={reqTableRow}
          />
          <Button
            sx={{ backgroundColor: "#3f51b5", width: "100px" }}
            variant="contained"
            onClick={sentToReview}
          >
            Submit
          </Button>
        </Paper>
      ) : (
        ""
      )}
    </>
  );
};

export default AddportfolioReview;
